import IndividualUser from 'modules/PlanConfiguration/individual-user';

export default function IndividualUserPage() {
  return <IndividualUser />;
}
